document.addEventListener("turbolinks:load", function() {
	var submitBtn = document.getElementById("cart_submit_bottom");
	var stickyBtn = document.getElementById("sticky_cart_button");
	if (!submitBtn || !stickyBtn) return;

	var observer = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			stickyBtn.style.display = entry.isIntersecting ? "none" : "block";
		});
	});

	observer.observe(submitBtn);
});
